<template>
  <quill-editor
    :disabled="disabled"
    v-model="input"
    ref="myQuillEditor"
    :options="editorOption"
  ></quill-editor>
</template>

<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import { quillEditor, Quill } from "vue-quill-editor";
import ImageUploader from "quill-image-uploader";
// import ImageResize  from 'quill-image-resize-module';

Quill.register("modules/imageUploader", ImageUploader);
// Quill.register('modules/imageResize', ImageResize);
export default {
  components: {
    quillEditor,
  },
  props: {
    content: {
      type: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    input: {
      set(newVal) {
        this.$emit("input", newVal);
      },
      get() {
        return this.content;
      },
    },
  },
  data() {
    return {
      editorOption: {
        placeholder: "متن مورد نظر ...",
        modules: {
          imageUploader: {
            upload: (file) => {
              return new Promise((resolve, reject) => {
                setTimeout(() => {
                  resolve(
                    "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/480px-JavaScript-logo.png"
                  );
                }, 3500);
              });
            },
          },
          toolbar: {
            handlers: {
              // handlers object will be merged with default handlers object
            },
            container: [
              [
                { size: ["small", false, "large", "huge"] },
                { header: [1, 2, 3, 4, 5, 6, false] },
              ],
              [
                "bold",
                "italic",
                "underline",
                { align: ["center", "right", "", "justify"] },
                "strike",
                { color: [] },
                { background: [] },
              ],
              [
                { list: "ordered" },
                { list: "bullet" },
                { indent: "-1" },
                { indent: "+1" },
              ],
              ["link"],
              //"image"
              ["clean"],
            ],
          },
        },
      },
    };
  },
};
</script>

<style lang="scss">
.ql-snow {
  .ql-tooltip {
    input[type="text"]::placeholder {
      opacity: 0;
    }
    &::before {
      content: "لینک مورد نظر:" !important;
    }
    a.ql-action::after {
      content: " ویرایش " !important;
    }
    a.ql-remove::before {
      content: " حذف " !important;
    }
  }
  &.ql-container {
    min-height: 150px;
  }
}
</style>
